import { api, ApiRes } from './client'

export interface Event {
    event: string
    data: Record<string, unknown>
    platform_name: string
    trackable_type: 'personal' | 'company'
}

export const postEvent = (event: Partial<Event>): ApiRes<undefined> => {
    return api.post('user-tracking', event)
}
